import type { Skill } from '../skillsData';

// ===== AI-Crypto Agents & Frameworks (from skills/ai-crypto/) =====
// ===== Analytics & Market Data (from skills/analytics/) =====

export const cryptoskillAiCryptoData: Skill[] = [

  // ──────────────────────────────────────────────────────────
  // AI / Agent Frameworks  (skills/ai-crypto/)
  // ──────────────────────────────────────────────────────────
  {
    id: 'eliza-framework',
    name: 'eliza-framework',
    author: 'ElizaOS',
    authorHandle: '@elizaos',
    tag: 'Skill',
    category: 'tools',
    description: 'Open-source multi-agent simulation framework. Build autonomous AI agents with persistent memory, multi-modal perception, and on-chain action capabilities.',
    downloads: 62400,
    stars: 3120,
    version: '1.0.0',
    installCommand: '> install the eliza-framework skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/ai-crypto/eliza-framework',
    usageExample: '> create eliza agent\n> deploy multi-agent swarm\n> configure persistent memory',
    detailedDescription: 'ElizaOS multi-agent simulation framework enabling autonomous AI agents with persistent memory, multi-modal perception, and composable action plugins for on-chain and off-chain operations.',
    featured: true,
    trending: true,
  },
  {
    id: 'goat-framework',
    name: 'goat-framework',
    author: 'GOAT SDK',
    authorHandle: '@goat_sdk',
    tag: 'Skill',
    category: 'tools',
    description: 'GOAT (Great Onchain Agent Toolkit) – composable plugin system for connecting AI agents to 200+ blockchain tools and protocols.',
    downloads: 41800,
    stars: 2080,
    version: '1.2.0',
    installCommand: '> install the goat-framework skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/ai-crypto/goat-framework',
    usageExample: '> add goat plugin\n> connect agent to uniswap\n> execute on-chain action',
    detailedDescription: 'GOAT SDK composable plugin system exposing 200+ Web3 tools to AI agents. Supports Langchain, Vercel AI SDK, and custom LLM frameworks via a unified interface.',
    featured: true,
    trending: true,
  },
  {
    id: 'bittensor-sdk',
    name: 'bittensor-sdk',
    author: 'Opentensor Foundation',
    authorHandle: '@opentensor',
    tag: 'Skill',
    category: 'tools',
    description: 'Official Bittensor SDK for AI agents. Query subnets, stake TAO, and participate in the decentralized AI network.',
    downloads: 23600,
    stars: 1180,
    version: '8.4.0',
    installCommand: '> install the bittensor-sdk skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/ai-crypto/bittensor-sdk',
    usageExample: '> query bittensor subnet\n> stake TAO tokens\n> run validator',
    detailedDescription: 'Official Bittensor Python SDK for interacting with decentralized AI subnets. Supports wallet management, staking, validator operations, and subnet querying.',
    featured: true,
  },
  {
    id: 'bittensor-taostats',
    name: 'bittensor-taostats',
    author: 'TaoStats',
    authorHandle: '@taostats',
    tag: 'Skill',
    category: 'analytics',
    description: 'TaoStats analytics integration. Real-time Bittensor network metrics, subnet rankings, validator performance, and TAO token analytics.',
    downloads: 11200,
    stars: 560,
    version: '1.1.0',
    installCommand: '> install the bittensor-taostats skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/ai-crypto/bittensor-taostats',
    usageExample: '> get subnet rankings\n> query validator APR\n> monitor TAO price',
    detailedDescription: 'TaoStats API integration providing comprehensive Bittensor network analytics, subnet performance metrics, validator rankings, and historical TAO data for AI agent decision-making.',
  },
  {
    id: 'virtuals-protocol',
    name: 'virtuals-protocol',
    author: 'Virtuals Protocol',
    authorHandle: '@virtuals_io',
    tag: 'Skill',
    category: 'tools',
    description: 'Create and deploy co-owned AI agents on the Virtuals Protocol. Tokenize agent access rights and manage autonomous agent economies.',
    downloads: 34500,
    stars: 1720,
    version: '2.0.0',
    installCommand: '> install the virtuals-protocol skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/ai-crypto/virtuals-protocol',
    usageExample: '> deploy virtuals agent\n> tokenize agent access\n> join agent economy',
    detailedDescription: 'Virtuals Protocol integration for creating co-owned AI agents with tokenized access rights. Deploy agents to the Base chain, manage VIRTUAL token economics, and build autonomous agent-to-agent transactions.',
    featured: true,
    trending: true,
  },
  {
    id: 'virtuals-official-acp',
    name: 'virtuals-official-acp',
    author: 'Virtuals Protocol',
    authorHandle: '@virtuals_io',
    tag: 'Skill',
    category: 'tools',
    description: 'Official Virtuals Agent Commerce Protocol (ACP). Enable agents to transact with each other, form on-chain jobs, and settle payments autonomously.',
    downloads: 18700,
    stars: 935,
    version: '1.0.0',
    installCommand: '> install the virtuals-official-acp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/ai-crypto/virtuals-official-acp',
    usageExample: '> post agent job\n> settle ACP transaction\n> query agent marketplace',
    detailedDescription: 'Virtuals Agent Commerce Protocol official implementation. Agents post on-chain jobs, bid for tasks, and settle payments in VIRTUAL tokens without human intervention.',
  },
  {
    id: 'heurist-official-mesh',
    name: 'heurist-official-mesh',
    author: 'Heurist AI',
    authorHandle: '@heurist_ai',
    tag: 'Skill',
    category: 'tools',
    description: 'Official Heurist Mesh – decentralized AI inference network. Run open-source LLMs, image generation, and structured data extraction on distributed GPU nodes.',
    downloads: 19800,
    stars: 990,
    version: '1.0.0',
    installCommand: '> install the heurist-official-mesh skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/ai-crypto/heurist-official-mesh',
    usageExample: '> call heurist llm\n> generate image via mesh\n> extract structured data',
    detailedDescription: 'Heurist Mesh official toolkit for accessing decentralized AI inference. Query LLaMA, Mistral, FLUX, and other open-source models on GPU-powered decentralized nodes with crypto payment settlement.',
    featured: true,
  },
  {
    id: 'chaingpt-official-claude-skill',
    name: 'chaingpt-official-claude-skill',
    author: 'ChainGPT',
    authorHandle: '@chaingpt_ai',
    tag: 'Skill',
    category: 'tools',
    description: 'Official ChainGPT AI skill. Access ChainGPT\'s blockchain-trained AI for smart contract auditing, token analysis, and crypto news generation.',
    downloads: 14600,
    stars: 730,
    version: '1.0.0',
    installCommand: '> install the chaingpt-official-claude-skill skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/ai-crypto/chaingpt-official-claude-skill',
    usageExample: '> audit smart contract\n> analyze token\n> generate crypto news',
    detailedDescription: 'ChainGPT official Claude marketplace skill providing blockchain-trained AI capabilities including smart contract auditing, token analysis, NFT generation, and real-time crypto news synthesis.',
  },
  {
    id: 'venice-private-ai',
    name: 'venice-private-ai',
    author: 'Venice AI',
    authorHandle: '@venice_ai',
    tag: 'Skill',
    category: 'tools',
    description: 'Venice private AI inference. Run LLMs with zero data retention and on-chain privacy guarantees. Ideal for sensitive financial and trading workflows.',
    downloads: 12400,
    stars: 620,
    version: '1.0.0',
    installCommand: '> install the venice-private-ai skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/ai-crypto/venice-private-ai',
    usageExample: '> run private inference\n> zero-retention analysis\n> confidential trading logic',
    detailedDescription: 'Venice AI private inference platform with guaranteed zero data retention. Execute LLM tasks with on-chain privacy, no training on user data, and transparent usage tracking.',
  },
  {
    id: 'eliza-plugin-defi',
    name: 'eliza-plugin-defi',
    author: 'ElizaOS',
    authorHandle: '@elizaos',
    tag: 'Skill',
    category: 'defi',
    description: 'Eliza DeFi plugin suite. Connects ElizaOS agents to DeFi protocols including swaps, lending, staking, and yield farming across multiple chains.',
    downloads: 16200,
    stars: 810,
    version: '0.9.0',
    installCommand: '> install the eliza-plugin-defi skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/ai-crypto/eliza-plugin-defi',
    usageExample: '> eliza swap tokens\n> eliza deposit aave\n> eliza farm yield',
    detailedDescription: 'ElizaOS DeFi plugin enabling agents to interact with Uniswap, Aave, Compound, Curve, and other major DeFi protocols. Supports multi-chain operations with automatic gas optimization.',
    trending: true,
  },
  {
    id: 'coinbase-developer-platform',
    name: 'coinbase-developer-platform',
    author: 'Coinbase',
    authorHandle: '@coinbase',
    tag: 'Skill',
    category: 'tools',
    description: 'Coinbase Developer Platform AI agent toolkit. MPC wallets, onramp/offramp, Base L2 interactions, and CDP API access for autonomous agents.',
    downloads: 38400,
    stars: 1920,
    version: '1.0.0',
    installCommand: '> install the coinbase-developer-platform skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/ai-crypto/coinbase-developer-platform',
    usageExample: '> create CDP wallet\n> onramp fiat to crypto\n> execute Base tx',
    detailedDescription: 'Official Coinbase Developer Platform AI integration. Create MPC-secured wallets, execute onramp/offramp, interact with Base L2, and access CDP APIs for building financial AI agents.',
    featured: true,
  },
  {
    id: 'minara-ai-crypto',
    name: 'minara-ai-crypto',
    author: 'Minara AI',
    authorHandle: '@minara_ai',
    tag: 'Skill',
    category: 'tools',
    description: 'Minara AI crypto assistant. Conversational AI specialized in crypto market analysis, portfolio management, and DeFi strategy with real-time data access.',
    downloads: 9800,
    stars: 490,
    version: '1.2.0',
    installCommand: '> install the minara-ai-crypto skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/ai-crypto/minara-ai-crypto',
    usageExample: '> ask market analysis\n> optimize portfolio\n> get DeFi strategy',
    detailedDescription: 'Minara AI crypto-specialized assistant with conversational interface for market analysis, portfolio optimization, and DeFi strategy generation using real-time on-chain and off-chain data.',
  },
  {
    id: 'universal-crypto-mcp',
    name: 'universal-crypto-mcp',
    author: 'Universal Crypto',
    authorHandle: '@universal_crypto',
    tag: 'Skill',
    category: 'tools',
    description: 'Universal Crypto MCP server. Single MCP interface for multi-chain wallet operations, price feeds, token swaps, and on-chain data across 20+ networks.',
    downloads: 15600,
    stars: 780,
    version: '1.0.0',
    installCommand: '> install the universal-crypto-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/ai-crypto/universal-crypto-mcp',
    usageExample: '> query multi-chain wallet\n> get price feed\n> execute cross-chain swap',
    detailedDescription: 'Universal Crypto Model Context Protocol server exposing a unified interface for wallet operations, price feeds, swaps, and on-chain queries across 20+ EVM and non-EVM networks.',
    trending: true,
  },
  {
    id: 'coinpilot-hyperliquid-copy-trade',
    name: 'coinpilot-hyperliquid-copy-trade',
    author: 'CoinPilot',
    authorHandle: '@coinpilot_ai',
    tag: 'Skill',
    category: 'trading',
    description: 'CoinPilot Hyperliquid copy-trading agent. Automatically mirror top traders on Hyperliquid perpetuals with configurable risk parameters.',
    downloads: 11400,
    stars: 570,
    version: '1.0.0',
    installCommand: '> install the coinpilot-hyperliquid-copy-trade skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/ai-crypto/coinpilot-hyperliquid-copy-trade',
    usageExample: '> follow top trader\n> set copy trade ratio\n> monitor positions',
    detailedDescription: 'CoinPilot AI agent for copy-trading on Hyperliquid DEX. Identify and mirror high-performing traders with configurable position sizing, stop-loss, and risk management parameters.',
    trending: true,
  },
  {
    id: 'motiv-arbitrage',
    name: 'motiv-arbitrage',
    author: 'Motiv Protocol',
    authorHandle: '@motiv_protocol',
    tag: 'Skill',
    category: 'trading',
    description: 'Motiv cross-exchange arbitrage agent. Detect and execute arbitrage opportunities between CEX and DEX venues with MEV-protected execution.',
    downloads: 8700,
    stars: 435,
    version: '1.0.0',
    installCommand: '> install the motiv-arbitrage skill from https://github.com/jiayaoqijia/cryptoskill/tree/main'  + '/skills/ai-crypto/motiv-arbitrage',
    usageExample: '> scan arb opportunities\n> execute CEX-DEX arb\n> set min profit threshold',
    detailedDescription: 'Motiv arbitrage agent scanning price discrepancies between centralized and decentralized exchanges. Executes with MEV protection, slippage control, and real-time P&L tracking.',
  },
  {
    id: 'selantar',
    name: 'selantar',
    author: 'Selantar',
    authorHandle: '@selantar',
    tag: 'Skill',
    category: 'tools',
    description: 'Selantar AI-powered dispute resolution agent for on-chain agreements. Autonomous mediation, evidence collection, and binding smart contract settlements.',
    downloads: 5400,
    stars: 270,
    version: '0.8.0',
    installCommand: '> install the selantar skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/ai-crypto/selantar',
    usageExample: '> file dispute\n> collect evidence\n> request mediation',
    detailedDescription: 'Selantar autonomous dispute mediation system for on-chain contracts. AI-powered evidence collection, neutral mediator assignment, and binding settlement execution via smart contracts.',
  },
  {
    id: 'billions-agent',
    name: 'billions-agent',
    author: 'Billions Protocol',
    authorHandle: '@billions_proto',
    tag: 'Skill',
    category: 'tools',
    description: 'Billions Protocol agent framework. Deploy multi-billion parameter AI agents on decentralized infrastructure with verifiable compute and on-chain governance.',
    downloads: 7800,
    stars: 390,
    version: '1.0.0',
    installCommand: '> install the billions-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/ai-crypto/billions-agent',
    usageExample: '> deploy billions agent\n> verify compute proof\n> govern agent params',
    detailedDescription: 'Billions Protocol framework for deploying large-scale AI agents with verifiable compute proofs on decentralized infrastructure. Supports on-chain governance, model updates, and performance attestations.',
  },
  {
    id: 'hashlock-mcp',
    name: 'hashlock-mcp',
    author: 'Hashlock',
    authorHandle: '@hashlock_io',
    tag: 'Skill',
    category: 'tools',
    description: 'Hashlock security MCP server. Real-time smart contract vulnerability scanning, audit trail verification, and rug-pull detection for AI agents.',
    downloads: 9200,
    stars: 460,
    version: '1.0.0',
    installCommand: '> install the hashlock-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/ai-crypto/hashlock-mcp',
    usageExample: '> scan contract security\n> verify audit trail\n> detect rug pull',
    detailedDescription: 'Hashlock security intelligence MCP server providing real-time smart contract vulnerability analysis, historical audit verification, and ML-based rug-pull detection for agent risk management.',
  },
  {
    id: 'prover-agent',
    name: 'prover-agent',
    author: 'ZK Prover Labs',
    authorHandle: '@zkproverlabs',
    tag: 'Skill',
    category: 'tools',
    description: 'ZK proof generation agent. Generate and verify zero-knowledge proofs on-demand for privacy-preserving agent operations and verifiable computation.',
    downloads: 6800,
    stars: 340,
    version: '1.0.0',
    installCommand: '> install the prover-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/ai-crypto/prover-agent',
    usageExample: '> generate zk proof\n> verify computation\n> prove private balance',
    detailedDescription: 'Zero-knowledge proof generation and verification agent supporting Groth16, PLONK, and STARKs. Generate privacy-preserving proofs for agent actions, balance attestations, and verifiable computations.',
  },
  {
    id: 'story-scoring-agent',
    name: 'story-scoring-agent',
    author: 'Story Protocol',
    authorHandle: '@storyprotocol',
    tag: 'Skill',
    category: 'tools',
    description: 'Story Protocol IP scoring agent. Evaluate, register, and monetize intellectual property assets on the Story Protocol blockchain with AI-driven valuation.',
    downloads: 5600,
    stars: 280,
    version: '1.0.0',
    installCommand: '> install the story-scoring-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/ai-crypto/story-scoring-agent',
    usageExample: '> score IP asset\n> register on story\n> monetize content',
    detailedDescription: 'Story Protocol AI agent for IP asset evaluation, registration, and monetization. Automatically assess originality, register assets on-chain, and configure revenue sharing parameters.',
  },

  // ──────────────────────────────────────────────────────────
  // Analytics & Market Data  (skills/analytics/)
  // ──────────────────────────────────────────────────────────
  {
    id: 'nansen-smart-money',
    name: 'nansen-smart-money',
    author: 'Nansen',
    authorHandle: '@nansen_ai',
    tag: 'Skill',
    category: 'analytics',
    description: 'Nansen Smart Money tracker. Follow high-conviction wallet clusters, detect early accumulation patterns, and monitor top DeFi protocol allocators.',
    downloads: 34600,
    stars: 1730,
    version: '2.0.0',
    installCommand: '> install the nansen-smart-money skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/nansen-smart-money',
    usageExample: '> track smart money wallets\n> detect accumulation\n> monitor top allocators',
    detailedDescription: 'Nansen Smart Money intelligence tracking 300M+ labeled wallet addresses. Identify early accumulation, monitor VC/fund positioning, detect token distribution patterns, and receive real-time smart money alerts.',
    featured: true,
    trending: true,
  },
  {
    id: 'nansen-portfolio',
    name: 'nansen-portfolio',
    author: 'Nansen',
    authorHandle: '@nansen_ai',
    tag: 'Skill',
    category: 'analytics',
    description: 'Nansen portfolio analytics. Comprehensive portfolio tracking, profit/loss attribution, DeFi position monitoring, and cross-chain balance aggregation.',
    downloads: 21800,
    stars: 1090,
    version: '2.0.0',
    installCommand: '> install the nansen-portfolio skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/nansen-portfolio',
    usageExample: '> track portfolio PnL\n> view DeFi positions\n> aggregate cross-chain',
    detailedDescription: 'Nansen portfolio intelligence with cross-chain balance aggregation, DeFi position tracking, realized/unrealized P&L, and gas cost attribution for comprehensive portfolio analysis.',
  },
  {
    id: 'nansen-token-screener',
    name: 'nansen-token-screener',
    author: 'Nansen',
    authorHandle: '@nansen_ai',
    tag: 'Skill',
    category: 'analytics',
    description: 'Nansen token screener. Filter tokens by smart money activity, holder quality, on-chain momentum, and liquidity depth across all major chains.',
    downloads: 18400,
    stars: 920,
    version: '2.0.0',
    installCommand: '> install the nansen-token-screener skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/nansen-token-screener',
    usageExample: '> screen tokens\n> filter by smart money\n> rank by holder quality',
    detailedDescription: 'Nansen token screener with 50+ filters including smart money inflows, holder concentration, trading velocity, liquidity depth, and social signal correlation for alpha discovery.',
    trending: true,
  },
  {
    id: 'nansen-holder-analysis',
    name: 'nansen-holder-analysis',
    author: 'Nansen',
    authorHandle: '@nansen_ai',
    tag: 'Skill',
    category: 'analytics',
    description: 'Nansen holder analysis. Deep-dive into token holder composition, classify wallets into CEX, VC, DeFi, and retail segments, track holder migration patterns.',
    downloads: 14600,
    stars: 730,
    version: '2.0.0',
    installCommand: '> install the nansen-holder-analysis skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/nansen-holder-analysis',
    usageExample: '> analyze token holders\n> classify wallet types\n> track holder churn',
    detailedDescription: 'Nansen holder composition intelligence classifying wallets into 10+ categories (CEX hot wallets, VC funds, DeFi power users, retail, etc.) with migration and concentration trend analysis.',
  },
  {
    id: 'defillama-official-defi-data',
    name: 'defillama-official-defi-data',
    author: 'DefiLlama',
    authorHandle: '@defillama',
    tag: 'Skill',
    category: 'analytics',
    description: 'Official DefiLlama DeFi data skill. Access TVL rankings, protocol revenue, chain metrics, and cross-protocol comparisons across 3000+ DeFi projects.',
    downloads: 52400,
    stars: 2620,
    version: '1.0.0',
    installCommand: '> install the defillama-official-defi-data skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/defillama-official-defi-data',
    usageExample: '> get protocol TVL\n> compare chain metrics\n> track revenue trends',
    detailedDescription: 'Official DefiLlama data integration covering TVL, revenue, fees, and user metrics for 3000+ protocols across 200+ chains. Real-time and historical data with normalization and category breakdowns.',
    featured: true,
    trending: true,
  },
  {
    id: 'defillama-yield-analytics',
    name: 'defillama-yield-analytics',
    author: 'DefiLlama',
    authorHandle: '@defillama',
    tag: 'Skill',
    category: 'analytics',
    description: 'DefiLlama yield analytics. Compare APY/APR across 10,000+ liquidity pools, filter by risk score, audit status, and TVL depth for optimal yield discovery.',
    downloads: 38600,
    stars: 1930,
    version: '1.0.0',
    installCommand: '> install the defillama-yield-analytics skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/defillama-yield-analytics',
    usageExample: '> compare yield pools\n> filter by risk score\n> find best APY',
    detailedDescription: 'DefiLlama yield aggregation covering 10,000+ LP pools and lending markets. Filter by risk tier, TVL minimum, audit status, IL exposure, and chain preference for data-driven yield optimization.',
    featured: true,
  },
  {
    id: 'dune-official-skills',
    name: 'dune-official-skills',
    author: 'Dune Analytics',
    authorHandle: '@dune',
    tag: 'Skill',
    category: 'analytics',
    description: 'Official Dune Analytics skill. Execute custom SQL queries against blockchain databases, access curated dashboards, and generate real-time on-chain reports.',
    downloads: 41200,
    stars: 2060,
    version: '1.0.0',
    installCommand: '> install the dune-official-skills skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/dune-official-skills',
    usageExample: '> run dune query\n> fetch dashboard data\n> generate on-chain report',
    detailedDescription: 'Official Dune Analytics integration executing SQL queries against decoded blockchain databases (Ethereum, Solana, Base, and 20+ chains), accessing 500k+ community dashboards, and scheduling reports.',
    featured: true,
  },
  {
    id: 'etherscan-api',
    name: 'etherscan-api',
    author: 'Etherscan',
    authorHandle: '@etherscan',
    tag: 'Skill',
    category: 'analytics',
    description: 'Etherscan API integration. Query Ethereum transaction history, contract ABIs, token transfers, gas prices, and ENS resolutions for agent intelligence.',
    downloads: 68400,
    stars: 3420,
    version: '2.0.0',
    installCommand: '> install the etherscan-api skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/etherscan-api',
    usageExample: '> get tx history\n> fetch contract ABI\n> query token transfers',
    detailedDescription: 'Full Etherscan API v2 integration supporting transaction lookup, contract verification, ERC-20/721/1155 transfers, gas oracle, ENS resolution, and account balance queries.',
    featured: true,
  },
  {
    id: 'coingecko-api',
    name: 'coingecko-api',
    author: 'CoinGecko',
    authorHandle: '@coingecko',
    tag: 'Skill',
    category: 'analytics',
    description: 'CoinGecko API skill. Access market prices, OHLCV data, trending tokens, exchange volumes, and DeFi protocol metrics for 15,000+ cryptocurrencies.',
    downloads: 76800,
    stars: 3840,
    version: '3.0.0',
    installCommand: '> install the coingecko-api skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/coingecko-api',
    usageExample: '> get token price\n> fetch OHLCV data\n> query trending coins',
    detailedDescription: 'CoinGecko Pro API with real-time prices, OHLCV, market caps, volumes, trending tokens, global crypto metrics, and DeFi protocol data for 15,000+ coins across 800+ exchanges.',
    featured: true,
  },
  {
    id: 'coinmarketcap-mcp',
    name: 'coinmarketcap-mcp',
    author: 'CoinMarketCap',
    authorHandle: '@coinmarketcap',
    tag: 'Skill',
    category: 'analytics',
    description: 'CoinMarketCap MCP server. Crypto market rankings, price alerts, portfolio tracking, and Fear & Greed Index via Model Context Protocol.',
    downloads: 48600,
    stars: 2430,
    version: '1.0.0',
    installCommand: '> install the coinmarketcap-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/coinmarketcap-mcp',
    usageExample: '> get CMC rankings\n> set price alert\n> query fear greed',
    detailedDescription: 'Official CoinMarketCap MCP integration exposing market rankings, real-time prices, historical OHLCV, Fear & Greed Index, trending tokens, and on-chain data via standardized MCP interfaces.',
    trending: true,
  },
  {
    id: 'fear-greed-index',
    name: 'fear-greed-index',
    author: 'Alternative.me',
    authorHandle: '@alternativeme',
    tag: 'Skill',
    category: 'analytics',
    description: 'Crypto Fear & Greed Index integration. Real-time market sentiment score (0-100), historical trends, and automatic trading signal generation.',
    downloads: 34800,
    stars: 1740,
    version: '2.0.0',
    installCommand: '> install the fear-greed-index skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/fear-greed-index',
    usageExample: '> get fear greed score\n> track sentiment trend\n> generate market signal',
    detailedDescription: 'Fear & Greed Index integration with current score, historical data, and automated signal generation. Synthesizes volatility, momentum, social media, surveys, dominance, and Google Trends data.',
  },
  {
    id: 'dexpaprika-dex-data',
    name: 'dexpaprika-dex-data',
    author: 'CoinPaprika',
    authorHandle: '@coinpaprika',
    tag: 'Skill',
    category: 'analytics',
    description: 'DexPaprika DEX analytics. On-chain pool data, swap volumes, liquidity depth, price impact, and new token listings across 30+ DEXes.',
    downloads: 19800,
    stars: 990,
    version: '1.0.0',
    installCommand: '> install the dexpaprika-dex-data skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/dexpaprika-dex-data',
    usageExample: '> query dex pools\n> get swap volume\n> find new listings',
    detailedDescription: 'DexPaprika comprehensive on-chain DEX analytics covering pool TVL, swap volumes, price impact curves, liquidity depth, and newly listed token discovery across Uniswap, PancakeSwap, Curve, and 30+ DEXes.',
  },
  {
    id: 'on-chain-detective',
    name: 'on-chain-detective',
    author: 'OnChain Detective',
    authorHandle: '@onchain_det',
    tag: 'Skill',
    category: 'analytics',
    description: 'On-chain forensics agent. Trace wallet funding sources, map transaction graphs, detect mixer usage, and generate risk profiles for compliance and research.',
    downloads: 15600,
    stars: 780,
    version: '1.0.0',
    installCommand: '> install the on-chain-detective skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/on-chain-detective',
    usageExample: '> trace wallet origin\n> map tx graph\n> generate risk profile',
    detailedDescription: 'Blockchain forensics agent for tracing wallet funding sources, mapping multi-hop transaction graphs, detecting privacy tool usage, and generating compliance risk reports.',
  },
  {
    id: 'crypto-intel-agent-analytics',
    name: 'crypto-intel-agent',
    author: 'Crypto Intel',
    authorHandle: '@cryptointel',
    tag: 'Skill',
    category: 'analytics',
    description: 'Crypto Intel multi-source intelligence agent. Aggregates on-chain data, news sentiment, social signals, and regulatory alerts into unified market intelligence.',
    downloads: 12400,
    stars: 620,
    version: '1.0.0',
    installCommand: '> install the crypto-intel-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/crypto-intel-agent',
    usageExample: '> get market intelligence\n> analyze news sentiment\n> monitor regulatory alerts',
    detailedDescription: 'Multi-source crypto intelligence platform aggregating on-chain metrics, news sentiment analysis, Twitter/Reddit signals, and regulatory monitoring into structured intelligence feeds for AI agents.',
  },
  {
    id: 'pyth-mcp-server',
    name: 'pyth-mcp-server',
    author: 'Pyth Network',
    authorHandle: '@pythnetwork',
    tag: 'Skill',
    category: 'analytics',
    description: 'Official Pyth Network MCP server. Sub-second price oracle feeds for 500+ assets via Model Context Protocol with on-demand price update proofs.',
    downloads: 28600,
    stars: 1430,
    version: '1.0.0',
    installCommand: '> install the pyth-mcp-server skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/pyth-mcp-server',
    usageExample: '> get pyth price feed\n> fetch price proof\n> subscribe to oracle',
    detailedDescription: 'Official Pyth Network MCP integration providing sub-second price oracle data for 500+ assets with verifiable price attestation proofs for on-chain smart contract integration.',
    featured: true,
    trending: true,
  },
  {
    id: 'defillama-agent-analytics',
    name: 'defillama-agent',
    author: 'DefiLlama',
    authorHandle: '@defillama',
    tag: 'Skill',
    category: 'analytics',
    description: 'DefiLlama agent helper. Natural language interface to DefiLlama data – ask about TVL, yields, protocol comparisons, and market trends conversationally.',
    downloads: 24800,
    stars: 1240,
    version: '1.0.0',
    installCommand: '> install the defillama-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/defillama-agent',
    usageExample: '> what is aave tvl\n> compare yields on base\n> trending protocols today',
    detailedDescription: 'Conversational DefiLlama agent interpreting natural language queries into structured API calls. Supports TVL questions, yield comparisons, protocol discovery, and historical trend analysis.',
  },
  {
    id: 'crypto-market-data-analytics',
    name: 'crypto-market-data',
    author: 'Market Data Pro',
    authorHandle: '@marketdatapro',
    tag: 'Skill',
    category: 'analytics',
    description: 'Aggregated crypto market data skill. Real-time tickers, order book snapshots, liquidation data, open interest, and funding rates from 50+ venues.',
    downloads: 31200,
    stars: 1560,
    version: '2.0.0',
    installCommand: '> install the crypto-market-data skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/crypto-market-data',
    usageExample: '> get aggregated prices\n> query open interest\n> fetch funding rates',
    detailedDescription: 'Unified market data aggregator pulling real-time prices, order books, OI, funding rates, and liquidation heatmaps from 50+ centralized and decentralized exchanges with 100ms refresh.',
  },
];